export default "__VITE_ASSET__DgcBJNes__"